// extracted by mini-css-extract-plugin
module.exports = {"grey700":"rgb(24,24,21)","checkBoxSize":"26px","checkBox":"CheckBox_checkBox__J16uP","selectedCheckBox":"CheckBox_selectedCheckBox__2lBEt CheckBox_checkBox__J16uP"};